module.exports = {
      id: "illustrations:NZ03-usage",
      viewBox: "0 0 321 355",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#illustrations:NZ03-usage",
      toString: function () {
        return this.url;
      }
    }